import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'ups-radio-group',
    templateUrl: './section-title.type.component.html',
    styleUrls: ['./section-title.type.component.scss'],
    standalone: false
})
export class SectionTitleComponent extends FieldType {}
